import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { accountingApi } from '../../services/accountingApi';
import { ExpenseCategory } from '../../types/accounting';
import '../../pages/Accounting.css';

interface CategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSaved: () => void;
  category: ExpenseCategory | null;
}

const CategoryModal: React.FC<CategoryModalProps> = ({ isOpen, onClose, onSaved, category }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setName(category ? category.name : '');
    setError('');
  }, [isOpen, category]);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Category name is required');
      return;
    }

    try {
      setLoading(true);
      if (category) {
        await accountingApi.updateExpenseCategory(category.id, { name: name.trim() });
        toast.success('Category updated successfully');
      } else {
        await accountingApi.createExpenseCategory(name.trim());
        toast.success('Category added successfully');
      }
      onSaved();
      onClose();
    } catch (err: any) {
      toast.error(err?.error || 'Failed to save category');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="acc-modal-overlay" onClick={onClose}>
      <div className="acc-modal" style={{ maxWidth: 400 }} onClick={(e) => e.stopPropagation()}>
        <div className="acc-modal-header">
          <h2>{category ? 'Edit Category' : 'Add Expense Category'}</h2>
          <button className="acc-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="acc-modal-body">
          <form onSubmit={handleSubmit}>
            <div className="acc-form-group">
              <label>Category Name <span className="acc-required">*</span></label>
              <input type="text" className={error ? 'error' : ''} value={name} onChange={(e) => setName(e.target.value)} disabled={loading} maxLength={100} placeholder="e.g. Salaries & Wages" />
              {error && <div className="acc-error-message">{error}</div>}
            </div>
            <div className="acc-form-actions">
              <button type="button" className="acc-btn acc-btn-secondary" onClick={onClose} disabled={loading}>Cancel</button>
              <button type="submit" className="acc-btn acc-btn-primary" disabled={loading}>{loading ? 'Saving...' : (category ? 'Save Changes' : 'Add Category')}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CategoryModal;
